import { render, staticRenderFns } from "./empty-data.vue?vue&type=template&id=a85de78e&scoped=true"
import script from "./empty-data.vue?vue&type=script&lang=js"
export * from "./empty-data.vue?vue&type=script&lang=js"
import style0 from "./empty-data.vue?vue&type=style&index=0&id=a85de78e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85de78e",
  null
  
)

export default component.exports